// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Phone: React.FC = () => {
    return <svg width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
    <g id="3.-Style" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g id="1.Iconography" transform="translate(-741.000000, -294.000000)" fill="currentColor">
            <g transform="translate(79.000000, 230.000000)">
                <g transform="translate(662.000000, 64.000000)">
                    <path d="M12,1.5 C17.7890625,1.5 22.5,6.2109375 22.5,12 C22.5,17.7890625 17.7890625,22.5 12,22.5 C6.2109375,22.5 1.5,17.7890625 1.5,12 C1.5,6.2109375 6.2109375,1.5 12,1.5 L12,1.5 Z M12,0 C5.37304688,0 0,5.37304688 0,12 C0,18.6269531 5.37304688,24 12,24 C18.6269531,24 24,18.6269531 24,12 C24,5.37304688 18.6269531,0 12,0 L12,0 Z M18.6899531,16.0122187 L18.6225469,15.8071406 C18.4643438,15.3354844 17.9428594,14.8432969 17.4623906,14.7114375 L15.6885,14.2265625 C15.2080313,14.0962031 14.5224844,14.2719844 14.1695156,14.625 L13.5278906,15.266625 C11.1958594,14.6352656 9.36628125,12.8056875 8.736375,10.4736562 L9.378,9.83203125 C9.7295625,9.48046875 9.90534375,8.79492188 9.77498438,8.313 L9.29151563,6.5390625 C9.16115625,6.05859375 8.66601563,5.53710938 8.19435938,5.37890625 L7.9921875,5.3115 C7.51903125,5.15329688 6.84375,5.31295313 6.4921875,5.66601563 L5.53125,6.62695313 C5.359875,6.796875 5.25,7.28465625 5.25,7.28615625 C5.21775,10.3359844 6.41310938,13.2729844 8.56935938,15.4306875 C10.71975,17.5810781 13.6465313,18.7749844 16.6860469,18.7485469 C16.7021719,18.7485469 17.204625,18.641625 17.376,18.4702031 L18.3369375,17.5092656 C18.6885,17.1591562 18.8466563,16.483875 18.6899531,16.0122187 Z"></path>
                </g>
            </g>
        </g>
    </g>
</svg>;
};

export default React.memo(Phone);
